import(/* webpackMode: "eager" */ "/home/runner/work/yegnaweb/yegnaweb/src/app/contact/page.tsx")